import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { MatDialog } from '@angular/material';
import { GroupObject } from 'app/models/group';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import { environment } from 'environments/environment';
import { UserService } from 'shared/services/User/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-subscription-home',
  templateUrl: './subscription-home.component.html',
  styleUrls: ['./subscription-home.component.scss']
})
export class SubscriptionHomeComponent implements OnInit {
  imageURL: string = environment.URL_TEAM_IMAGES;

  constructor(
    private router: Router,
    private data: DataSharingService,

  ) { }

  ngOnInit() {
    this.data.changeTitle('SUBSCRIPTIONS');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/group/components/subscription-home/subscription-home.component.ts